import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { PageTitle, Panel, Field, TextInput, Select, Btn } from "../components/ui";
import { useI18n } from "../i18n";
import { CL } from "../api";

const SECTORS = ["Üretim", "Enerji", "İnşaat", "Perakende", "Hizmet", "Lojistik", "Tarım", "Diğer"];

export default function Entity() {
  const { t } = useI18n();
  const [e, setE] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => { CL.getEntity().then(setE).catch(() => {}); }, []);
  if (!e) return null;

  const up = (k) => (ev) => { const v = ev.target.value; setE((prev) => ({ ...prev, [k]: v })); };

  const save = async () => {
    setSaving(true);
    try {
      const payload = {
        name: e.name || "", sector: e.sector || "", country: e.country || "Türkiye",
        currency: e.currency || "TRY",
        reporting_year: Number(e.reporting_year) || 2025,
        base_year: Number(e.base_year) || 2024,
        employees: e.employees === "" || e.employees == null ? null : Number(e.employees),
        revenue: e.revenue === "" || e.revenue == null ? null : Number(e.revenue),
      };
      const saved = await CL.updateEntity(payload);
      setE(saved);
      toast.success(t("saved"));
    } catch { toast.error("Error"); }
    finally { setSaving(false); }
  };

  return (
    <div data-testid="entity-page">
      <PageTitle title={t("entity")} subtitle={t("entityTitle")} />
      <Panel className="max-w-3xl">
        <div className="grid grid-cols-1 gap-5 md:grid-cols-2">
          <Field label={t("name")}><TextInput data-testid="entity-name" value={e.name || ""} onChange={up("name")} placeholder="Örn. Enasus Endüstri A.Ş." /></Field>
          <Field label={t("sector")}>
            <Select data-testid="entity-sector" value={e.sector || ""} onChange={up("sector")}>
              <option value="">—</option>
              {SECTORS.map((s) => <option key={s} value={s}>{s}</option>)}
            </Select>
          </Field>
          <Field label={t("country")}><TextInput data-testid="entity-country" value={e.country || ""} onChange={up("country")} /></Field>
          <Field label={t("currency")}><TextInput data-testid="entity-currency" value={e.currency || ""} onChange={up("currency")} /></Field>
          <Field label={t("reportingYear")}><TextInput type="number" data-testid="entity-reporting-year" value={e.reporting_year ?? ""} onChange={up("reporting_year")} /></Field>
          <Field label={t("baseYear")}><TextInput type="number" data-testid="entity-base-year" value={e.base_year ?? ""} onChange={up("base_year")} /></Field>
          <Field label={t("employees")}><TextInput type="number" data-testid="entity-employees" value={e.employees ?? ""} onChange={up("employees")} /></Field>
          <Field label={t("revenue")}><TextInput type="number" data-testid="entity-revenue" value={e.revenue ?? ""} onChange={up("revenue")} /></Field>
        </div>
        <div className="mt-6">
          <Btn onClick={save} disabled={saving} data-testid="entity-save">{saving ? "..." : t("save")}</Btn>
        </div>
      </Panel>
    </div>
  );
}
